<template>
  <div>
    <div class="container-fluid">
      <v-row class="app-course">
        <v-col cols="12" sm="12" md="12">
          <h2>Aprender sempre,<br/> a cada momento e em todo lugar!</h2>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <!-- <v-text-field class="input-search-home" label="Solo" placeholder="Buscar curso" solo v-model="search"></v-text-field> -->
          <v-text-field
            label="Pesquise pelo curso que deseja fazer"
            single-line
            outlined
            class="input-search"
            prepend-inner-icon="search"
            v-model="term"
            @click:prepend="doSearchTerm"
            @keyup.enter="doSearchTerm"
          ></v-text-field>
        </v-col>

        <!-- <banner-home></banner-home> -->

        <!--<v-col cols="12" sm="12" md="3" class="content-search-page content-search-page-app">
          <v-expansion-panels
            focusable
            flat
            :aria-expanded="true"
          >
            <v-expansion-panel>
              <v-expansion-panel-header :disabled="loadingCategories">
                Categorias
              </v-expansion-panel-header>
              <v-expansion-panel-content class="filter-itens">
                <v-checkbox v-model="selectedCategories" v-for="(category, i) in categories" :key="`c${i}`"
                            color="#1172BB" :label="category.name" :value="category._id"></v-checkbox>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>
                Preço
              </v-expansion-panel-header>
              <v-expansion-panel-content class="filter-itens">
                <v-checkbox v-model="selectedPrices" v-for="(price, i) in prices" :key="`p${i}`" color="#1172BB"
                            :label="`até R$ ${price}`" :value="price"></v-checkbox>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>
                Duração do curso
              </v-expansion-panel-header>
              <v-expansion-panel-content class="filter-itens">
                <v-checkbox v-model="selectedDuration" v-for="(duration, i) in durations" :key="`d${i}`" color="#1172BB"
                            :label="showDurationLabel(duration)" :value="duration"></v-checkbox>
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
        </v-col>-->

        <v-col cols="12" sm="12" md="12" class="content-search-page content-search-page-app">
          <div class="filters-selected filters-selected-app"
               v-if="selectedCategories.length || selectedPrices.length || selectedDuration.length">
              <span v-for="(categoryId, i) in selectedCategories" :key="`sc${i}`">
                {{ showCategoryName(categoryId) }} <v-icon @click="removeCategories(categoryId)">close</v-icon>
              </span>
            <span v-for="(price, i) in selectedPrices" :key="`sp${i}`">
                até R$ {{ price }} <v-icon @click="selectedPrices.splice(i, 1)">close</v-icon>
              </span>
            <span v-for="(duration, i) in selectedDuration" :key="`sd${i}`">
                {{ showDurationLabel(duration) }} <v-icon @click="selectedDuration.splice(i, 1)">close</v-icon>
              </span>
          </div>

          <!--
                    <div class="filters-selected filters-selected-app"
                         v-if="selectedCategories.length || selectedPrices.length || selectedDuration.length">
                        <span v-for="(el, i) in selectedCategories" :key="i">
                          {{ el }} <v-icon @click="selectedCategories.splice(i, 1)">close</v-icon>
                        </span>
                      <span v-for="(el, i) in selectedPrices" :key="i">
                          {{ el }} <v-icon @click="selectedPrices.splice(i, 1)">close</v-icon>
                        </span>
                      <span v-for="(el, i) in selectedDuration" :key="i">
                          {{ el }} <v-icon @click="selectedDuration.splice(i, 1)">close</v-icon>
                        </span>
                    </div>
          -->

          <!-- CARDS CURSOS -->
          <v-row v-if="!loading">
            <v-col cols="12" sm="12" md="4" lg="3" class="card-course card-course-app" v-for="(course, i) in courses"
                   :key="i">
              <router-link :to="{ name: 'course-page', params: { slug: course.slug }}">
                <div class="card-course-div">
                  <div :style="{ backgroundImage: 'url(' + course.imageUrl + ')' }" class="img-course"
                       v-if="course.imageUrl"></div>
                  <div class="img-course" v-else></div>
                  <h4>{{ course.title }}</h4>
                  <h5>{{ course.user }}</h5>
                  <v-btn class="outline" color="success" dark>Ver mais</v-btn>
                </div>
              </router-link>
            </v-col>

            <!--
                        <v-col cols="12" sm="12" md="6" lg="4" class="card-course card-course-app">
                          <router-link :to="{ name: 'course-page', params: { courseId: 456 }}">
                            <div class="card-course-div">
                              &lt;!&ndash; <div :style="{ backgroundImage: 'url(' + course.imageUrl + ')' }" class="img-course" v-if="course.imageUrl"></div> &ndash;&gt;
                              <div class="img-course"></div>
                              <h4>Educação financeira para crianças</h4>
                              <h5>Viamaker Education</h5>
                              <v-btn class="outline" color="primary" dark>Ver mais</v-btn>
                            </div>
                          </router-link>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" lg="4" class="card-course card-course-app">
                          <router-link :to="{ name: 'course-page', params: { courseId: 789 }}">
                            <div class="card-course-div">
                              &lt;!&ndash; <div :style="{ backgroundImage: 'url(' + course.imageUrl + ')' }" class="img-course" v-if="course.imageUrl"></div> &ndash;&gt;
                              <div class="img-course"></div>
                              <h4>Lógica de programação do básico ao avançado</h4>
                              <h5>Smartoys</h5>
                              <v-btn class="outline" color="primary" dark>Ver mais</v-btn>
                            </div>
                          </router-link>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" lg="4" class="card-course card-course-app">
                          <router-link :to="{ name: 'course-page', params: { courseId: 987 }}">
                            <div class="card-course-div">
                              &lt;!&ndash; <div :style="{ backgroundImage: 'url(' + course.imageUrl + ')' }" class="img-course" v-if="course.imageUrl"></div> &ndash;&gt;
                              <div class="img-course"></div>
                              <h4>Educação financeira para crianças</h4>
                              <h5>Viamaker Education</h5>
                              <v-btn class="outline" color="primary" dark>Ver mais</v-btn>
                            </div>
                          </router-link>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" lg="4" class="card-course card-course-app">
                          <router-link :to="{ name: 'course-page', params: { courseId: 654 }}">
                            <div class="card-course-div">
                              &lt;!&ndash; <div :style="{ backgroundImage: 'url(' + course.imageUrl + ')' }" class="img-course" v-if="course.imageUrl"></div> &ndash;&gt;
                              <div class="img-course"></div>
                              <h4>Lógica de programação do básico ao avançado</h4>
                              <h5>Smartoys</h5>
                              <v-btn class="outline" color="primary" dark>Ver mais</v-btn>
                            </div>
                          </router-link>
                        </v-col>
            -->
          </v-row>

          <v-row v-else>
            <v-col cols="12" sm="12" class="text-xs-center loader-app">
              <font-awesome-icon :icon="['fas', 'spinner']" color="red" spin size="5x" class="mr-1"/>
              <br/>
              <p>Carregando <br/>cursos</p>
            </v-col>
          </v-row>
          <v-row v-if="!loading && !courses.length">
            <v-col cols="12" sm="12">
              <v-alert :value="true" type="info" class="white-text">Nenhum curso encontrado</v-alert>
            </v-col>
          </v-row>
        </v-col>


        <!--
                <v-col cols="12" sm="12" sm6 md4 lg3 class="mb-4" v-for="(course, i) in courses" :key="i">
                  <card-course :course="course" :permission-to-edit="permissionToEdit"
                               @removeCourse="removeCourseFromList"></card-course>
                </v-col>
        -->

      </v-row>
    </div>
    <v-snackbar
      v-model="alert.show"
      :color="alert.color"
    >
      {{ alert.text }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
// import CardCourse from '@/components/User/CardCourse'
import _ from 'lodash'

library.add(faSpinner)

export default {
  name: 'Courses',
  // components: { CardCourse },
  data () {
    return {
      loading: false,
      loadingCategories: false,
      term: '',
      courses: [],
      permissionToEdit: false,
      selectedCategories: [],
      selectedPrices: [],
      selectedDuration: [],
      categories: [],
      prices: [50, 100, 150, 200, 300, 400, 500],
      durations: [
        { min: 0, max: 2 },
        { min: 3, max: 6 },
        { min: 7, max: 10 },
        { min: 10 },
      ],
      alert: {
        show: false,
        text: null,
        color: null
      }
    }
  },
  computed: {
    ...mapGetters(['permissions'])
  },
  watch: {
    selectedCategories () {
      this.debouncedGetCourses()
    },
    selectedPrices () {
      this.debouncedGetCourses()
    },
    selectedDuration () {
      this.debouncedGetCourses()
    }
  },
  created () {
    this.getCategories()
    this.getCourses()

    this.debouncedGetCourses = _.debounce(this.getCourses, 200)
  },
  methods: {
    doSearchTerm () {
      this.debouncedGetCourses()
    },
    getCategories () {
      this.loadingCategories = true

      this.axios('/public/categories/combo').then(({ data }) => {
        if (data.success) {
          this.categories = data.categories
        }
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        this.loadingCategories = false
      })
    },
    getCourses () {
      this.loading = true

      const data = {
        categories: this.selectedCategories,
        prices: this.selectedPrices,
        durations: this.selectedDuration,
        term: this.term
      }

      this.axios.post('/public/course/search', data).then(({ data }) => {
        if (data.success) {
          this.courses = data.courses
        } else {
          this.alert.text = data.message
          this.alert.color = 'error'
          this.alert.show = true
        }
      }).catch(err => {
        console.error(err)

        this.alert.text = 'Erro ao buscar o curso'
        this.alert.color = 'error'
        this.alert.show = true
      }).finally(() => {
        this.loading = false
      })
    },
    showCategoryName (categoryId) {
      const category = this.categories.find(cat => cat._id === categoryId)

      if (!category) {
        return null
      }

      return category.name
    },
    showDurationLabel (duration) {
      if (duration.hasOwnProperty('min') && duration.hasOwnProperty('max')) {
        return `${duration.min}-${duration.max} Horas`
      }

      if (duration.hasOwnProperty('min') && !duration.hasOwnProperty('max')) {
        return `+${duration.min} Horas`
      }

      return null
    },
    removeCategories (categoryId) {
      // const index = this.selectedCategories.findIndex(catId => catId === categoryId)

      this.selectedCategories.splice(0, 1)

      // this.setPublicFilters({
      //   categories: this.selectedCategories.splice(0, 1)
      // })
    },
  }
}
</script>
